
























import {
  defineComponent, useContext, ref, useRoute, watch, useRouter, onMounted,
} from '@nuxtjs/composition-api';
import { addBasePath } from '~/helpers/addBasePath';
import { SfImage } from '~/components/StorefrontUi';

export default defineComponent({
  name: 'LangSelect',
  components: {
    SfImage,
  },
  setup() {
    const { app, localePath } = useContext();
    const route = useRoute();
    const router = useRouter();

    const getLangIconName = (code: string) => {
      switch (code) {
        case 'en':
          return 'en_US';
        case 'pl':
          return 'pl_PL';
        default:
          return 'pl_PL';
      }
    };

    const languageOptions = app.i18n.locales.map((locale) => ({
      label: locale.label || locale.code.toUpperCase(),
      value: locale.code,
      iconName: locale.iso,
    }));
    const initialLanguage = languageOptions.find(
      (option) => option.value === app.i18n.locale,
    );
    const selectedLanguage = ref(
      initialLanguage ? initialLanguage.value : app.i18n.defaultLocale,
    );

    const changeLanguage = (event: Event) => {
      const selectedValue = (event.target as HTMLSelectElement).value;
      if (languageOptions.find((lang) => lang.value === selectedValue)) {
        app.i18n.setLocale(selectedValue);
      }
    };

    watch(
      () => app.i18n.locale,
      (newVal) => {
        selectedLanguage.value = newVal;
      },
    );

    return {
      languageOptions,
      selectedLanguage,
      changeLanguage,
      addBasePath,
      getLangIconName,
    };
  },
});
